import { Props_SnippetQuotesCarousel } from "./QuotesCarousel.props"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, A11y, EffectFade, Pagination } from 'swiper/modules'
import SwiperControls, { swiperNavigationOptions, swiperPaginationOptions } from '../Shared/SwiperControls/SwiperControls'
import { Legacy_CompileMarkdown } from "@ClientBase/React/ReactSnippetMDCompiler"

const SnippetquotesCarousel = (props: Props_SnippetQuotesCarousel) => {
    const { heading, snippet, repeatable_quotesCarouselOptions } = props;
    const { background_color, background_image, text_color } = snippet;

    const carouselId = "quotes-carousel"

    const backgroundImageStyle = background_image?.value ? { backgroundImage: `url(${background_image.value})` } : {}
    const backgroundColorClass = background_color?.value ? ` snippet-quotes-carousel--bg-${background_color.value}` : ''
    const textColorClass = text_color?.value ? ` snippet-quotes-carousel--text-${text_color.value}` : ''

    return (
        <section className="snippet-quotes-carousel">
            <div className="snippet-quotes-carousel__container">
                <h2 className={`snippet-quotes-carousel__heading ${heading.visibility?.value ? '' : 'snippet-quotes-carousel__heading--hidden'}`}>{ heading.content?.value }</h2>
                <Swiper
                    className="snippet-quotes-carousel__swiper"
                    modules={[Navigation, EffectFade, Pagination, A11y]}
                    navigation={{
                        ...swiperNavigationOptions,
                        prevEl: `.swiper-navigation__button-prev-${carouselId}`,
                        nextEl: `.swiper-navigation__button-next-${carouselId}`,
                    }}
                    pagination={{
                        ...swiperPaginationOptions,
                        clickable: true,
                        dynamicBullets: false,
                        el: `.swiper-pagination-${carouselId}`,
                    }}
                    slidesPerView={1}
                    fadeEffect={{ crossFade: true }}
                    effect="fade"
                    height={320}
                >
                    {repeatable_quotesCarouselOptions && repeatable_quotesCarouselOptions.map((item, index) => (
                        <SwiperSlide key={index} className="snippet-quotes-carousel__slide">
                            <div
                                className={`snippet-quotes-carousel__card ${backgroundColorClass} ${textColorClass}`}
                                style={backgroundImageStyle}>
                                <div className="snippet-quotes-carousel__card-content">
                                    {item.content?.value && (
                                        <div className="snippet-quotes-carousel__card-text">
                                            {Legacy_CompileMarkdown(item.content.value)}
                                        </div>
                                    )}
                                    {(item.author?.value || item.role?.value) && (
                                        <div className="snippet-quotes-carousel__card-author">
                                            {item.author?.value && (
                                                <p className="snippet-quotes-carousel__card-author-name">{item.author.value}</p>
                                            )}
                                            {item.role?.value && (
                                                <p className="snippet-quotes-carousel__card-author-role">{item.role.value}</p>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <SwiperControls 
                    uniqueId={carouselId}
                    className="snippet-quotes-carousel__navigation"
                />
            </div>
        </section>
    )
}

export default SnippetquotesCarousel
